module.exports = __webpack_public_path__ + "img/rexnord-logo.36acbbdd.jpg";